import { Award, Rocket, Shield, Sparkles, Zap } from "lucide-react";
import React from "react";

const HyvidAdCard = () => {
  return (
    <div className="relative group gradient-effect">
      <div className="hover-effect group-hover:opacity-10 transition-opacity"></div>

      <div className="text-card-foreground flex flex-col gap-6 rounded-xl relative p-8 border-2 border-purple-100 bg-gradient-to-br from-purple-50/30 to-emerald-50/30">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 icon-effect gradient-primary">
            <Rocket className="w-6 h-6 text-white"/>
          </div>
          <h2 className="text-gray-800 text-xl font-medium">Be the Future of Work. Join Hyvid.</h2>
        </div>

        <div className="space-y-4 text-gray-700 mb-8">
          <p>
            At Hyvid, we aren't just filling roles; we are building a new class of
            global professionals. We believe the future of work isn't about where you
            are, but how you perform. That is why we have replaced the traditional
            office with a seamless, 100% remote digital infrastructure that empowers
            you to work from the comfort of your home.
          </p>
          <p>
            We combine world-class human talent with advanced AI integration. As a
            Hyvid professional, you won't just be an employee; you will be an
            AI-Native expert, equipped with personal AI Copilots to automate the
            mundane and amplify your potential. We invest deeply in your growth
            through our proprietary AI Readiness Training and continuous upskilling
            programs, ensuring you stay at the cutting edge of your industry.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-lg text-gray-900 mb-4 flex items-center gap-2 font-medium">
            <span className="w-1 h-6 bg-gradient-to-b from-purple-600 to-emerald-600 rounded-full"></span>
            Why Build Your Career with Hyvid?
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex gap-3">
              <div className="w-10 h-10 bg-gradient-to-br from-purple-100 to-purple-200 rounded-lg flex items-center justify-center flex-shrink-0">
                <Zap className="w-5 h-5 text-purple-600"/>
              </div>
              <div>
                <h4 className="text-gray-900 mb-1 font-medium">True Remote Freedom</h4>
                <p className="text-gray-600">
                  Work from home with a connected digital ecosystem that keeps you
                  visible and supported.
                </p>
              </div>
            </div>

            <div className="flex gap-3">
              <div className="w-10 h-10 bg-gradient-to-br from-emerald-100 to-emerald-200 rounded-lg flex items-center justify-center flex-shrink-0">
                <Sparkles className="w-5 h-5 text-emerald-600"/>
              </div>
              <div>
                <h4 className="text-gray-900 mb-1 font-medium">Future-Proof Skills</h4>
                <p className="text-gray-600">
                  Gain a professional edge with hands-on AI training and workflow
                  automation tools.
                </p>
              </div>
            </div>

            <div className="flex gap-3">
              <div className="w-10 h-10 bg-gradient-to-br from-purple-100 to-emerald-200 rounded-lg flex items-center justify-center flex-shrink-0">
                <Shield className="w-5 h-5 text-purple-600"/>
              </div>
              <div>
                <h4 className="text-gray-900 mb-1 font-medium">Top-Tier Benefits</h4>
                <p className="text-gray-600">
                  We support our team with competitive pay, healthcare, and government
                  benefits designed for your well-being.
                </p>
              </div>
            </div>

            <div className="flex gap-3">
              <div className="w-10 h-10 bg-gradient-to-br from-emerald-100 to-purple-200 rounded-lg flex items-center justify-center flex-shrink-0">
                <Award className="w-5 h-5 text-emerald-600"/>
              </div>
              <div>
                <h4 className="text-gray-900 mb-1 font-medium">Culture of Excellence</h4>
                <p className="text-gray-600">
                  Join a community that celebrates impact through our global Rewards &amp;
                  Recognition programs.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-4 border-t border-purple-200">
            <span className="flex justify-center gap-1 bg-gradient-to-r from-purple-600 to-emerald-600 bg-clip-text text-transparent text-center">
                <p className="label-gradient">Stop just working. Start evolving.</p>
                <p>Join Hyvid and become part of the world's smartest team.</p>
            </span> 
        </div>
      </div>
    </div>
  );
};

export default HyvidAdCard;
